<template>
    <router-view/>
</template>

<script>

export default {
  name: 'App',
  created () {
    let loader = null
    let pendingRequests = 0
    let vueComponent = this

    // EdF: Contador de peticiones en vuelo. Antes el overlay se ocultaba en cuanto respondía CUALQUIER
    // petición, aunque quedaran otras en curso, y la siguiente lo volvía a crear. Con varias llamadas
    // encadenadas (p.ej. el listado de sesiones: clases + N matrículas + N grabaciones) eso producía un
    // parpadeo continuo. Ahora se muestra con la primera y se oculta solo al asentarse la última.
    function showLoader () {
      pendingRequests++
      if (loader == null) {
        loader = vueComponent.$loading.show()
      }
    }

    function hideLoader () {
      pendingRequests = Math.max(0, pendingRequests - 1)
      if (pendingRequests === 0) {
        loader && loader.hide()
        loader = null
      }
    }

    // EdF: Una petición es "de fondo" si su config lleva `background: true`. Son las que no
    // nacen de una acción del usuario y no deben interrumpirle: el guardado periódico de
    // posición de videoResumeMixin, que dispara un PATCH cada 12s mientras se ve el vídeo.
    // Taparle la reproducción con el overlay —o sacarle un toast de error cada 12s si el
    // backend falla— sería peor que perder el punto de reanudación. El defecto es false, así
    // que cualquier llamada que no lo pida explícitamente sigue mostrando loader y errores.
    // Ojo: si se silencia el error hay que asegurarse de que quien la lanza maneje el rechazo.
    function isBackgroundRequest (config) {
      return Boolean(config && config.background)
    }

    function loaderWasShown (config) {
      return Boolean(config && config.loaderShown)
    }

    window.axios.interceptors.request.use(
      (config) => {
        // CMM: En todas las peticiones se envía el token
        const token = vueComponent.$cookies.get('LTI_JWT')
        if (token != null) {
          config.headers.Authorization = 'Bearer ' + token
        }
        config.baseURL = '/api/v1'

        // CMM: Se muestra spinner de carga
        // EdF: Se marca la config de las peticiones que SÍ han incrementado el contador, para que
        // el interceptor de respuesta solo decremente por ellas. Sin la marca hay que deducirlo, y
        // se deducía mal: un rechazo originado aquí llega a la respuesta sin haber mostrado nunca
        // el loader, y aun así lo ocultaba, descuadrando el contador de las peticiones en vuelo.
        if (!isBackgroundRequest(config)) {
          config.loaderShown = true
          showLoader()
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    function showError (error) {
      // EdF: En fallos de red, timeouts o cuando el rechazo viene del propio interceptor de petición no
      // existe error.response, y leerlo a ciegas lanzaba un TypeError que enmascaraba el error real y
      // dejaba al usuario sin ningún aviso. El cuerpo tampoco es siempre un objeto con message: las
      // descargas usan responseType 'blob', así que un error ahí llega como Blob.
      let response = error.response ? error.response.data : null
      let message = response && response.message
        ? vueComponent.$i18n.t(response.message)
        : vueComponent.$i18n.t('errors.unexpected')

      if (response && typeof response.errors !== 'undefined' && response.errors.length > 0) {
        message += '('
        for (let i = 0; i < response.errors.length; i++) {
          message += '\n' + vueComponent.$i18n.t(response.errors[i].message)
        }
        message += ')'
      }

      if (message) {
        vueComponent.$noty.error(message, {
          closeWith: ['button']
        })
      }
    }

    window.axios.interceptors.response.use(
      (response) => {
        // hide loader
        if (loaderWasShown(response.config)) {
          hideLoader()
        }
        return response
      },
      (error) => {
        // hide loader. Un rechazo del propio interceptor de petición llega sin error.config: no
        // mostró loader, así que tampoco lo oculta, pero sí se avisa del error porque no es una
        // petición de fondo (no hay config donde declararlo).
        if (loaderWasShown(error.config)) {
          hideLoader()
        }
        if (!isBackgroundRequest(error.config)) {
          showError(error)
        }
        return Promise.reject(error)
      }
    )
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue